import { zfUtils } from "./zf_utils";
export class zfccustom {
    static init(viewer) {
        $(".zfccustom").each(function () {
            if (zfUtils.isCookieTypeAllowed($(this).data("cookietype")))
                $(this).append($(this).data("code"));
        });
        return true;
    }
}
try {
    zfUtils.onReady(zfccustom.init);
}
catch (err) {
    console.log("Initalization failed: zfccustom.init() " + err.message);
}
